import { api } from './client.js';

const root = '/admin/logs';

export const logsApi = {
  byRequestId: (requestId) => api.get(`${root}/by-request/${requestId}`),
  listRequests: (params) => api.get(`${root}/requests`, { query: params }),
  listErrors: (params) => api.get(`${root}/errors`, { query: params }),
  listAudit: (params) => api.get(`${root}/audit`, { query: params }),
  listAuthAudit: (params) => api.get(`${root}/auth-audit`, { query: params }),
  auditFacets: () => api.get(`${root}/audit/facets`),
  authAuditFacets: () => api.get(`${root}/auth-audit/facets`)
};
